import setPurchaseHistoryConfig from "@NA/Handlers/PurchaseHistory/SetPurchaseHistoryConfig";
import { PurchaseHistoryPaginationModel } from "@NA/Services/GetMyPurchaseHistory";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import React from "react";
import { FC } from "react";
import { ResolveThunks, connect } from "react-redux";

const mapStateToProps = (state: CustomApplicationState) => ({
    pagination: state.ADIGlobalData.myPurchaseHistoryStore.myPurchaseHistory?.pagination,
    myPurchaseHistoryConfig: state.ADIGlobalData.myPurchaseHistoryConfig,
});

const mapDispatchToProps = {
    setPurchaseHistoryConfig,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PurchaseHistoryPageSizeStyles {
    pagination?: PaginationPresentationProps;
}

export const purchaseHistoryPageSizeStyles: PurchaseHistoryPageSizeStyles = {
};

const styles = purchaseHistoryPageSizeStyles;

export const PurchaseHistoryPageSize: FC<Props> = ({ pagination, setPurchaseHistoryConfig, myPurchaseHistoryConfig }) => {    
    if (!pagination || !pagination.totalItemCount) {
        return null;
    }

    const changePage = (newPageIndex: number) => {
        const updatedPagination: PurchaseHistoryPaginationModel = {
            ...myPurchaseHistoryConfig.pagination,
            page: newPageIndex,
        };
        setPurchaseHistoryConfig({
            ...myPurchaseHistoryConfig,
            pagination: updatedPagination,
        });
    };

    return (
        <StyledWrapper>
            <Pagination
                {...styles.pagination}
                currentPage={pagination.currentPage}
                resultsPerPage={pagination.pageSize}
                resultsCount={pagination.totalItemCount}
                resultsPerPageOptions={[]}
                onChangePage={changePage}
                onChangeResultsPerPage={() => {}}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(PurchaseHistoryPageSize),
    definition: {
        group: "My Account",
        displayName: "Purchase History Pagination",
        fieldDefinitions: [],
    },
};

export default widgetModule;
